import { DesignProp } from "../PropCategories";

export const backgroundColor = {
  prop: "style-attribute",
  name: "Background color",
  nameI18n: "builder_ui.prop_type.styles.background_color",
  category: [DesignProp],
  type: "color",
  defaultValue: "#000000",
} as const;
